<template>
  <!-- Card product require
      - image
      - name
      -url
      -price
      -custom attribute (Exclusive online)
    -->
  <div class="block-product card-product-teaser">
    <div class="card-product-teaser__media">
      <a href="javascript:;" @click.prevent="$emit('productClicked', product)">
        <image-gallery
        :imgPath="productImage"
        :alt="product.name"
        size="MD"
        :defaultLoading="require('theme/assets/image/dump.png')"
        :styleImage="{ maxWidth: '100%', height: 'auto' }"
        :changeAble="false"/>
      </a>
    </div>
    <div class="card-product-teaser__info">
      <div class="card-product-teaser__info__intro">
        <a href="javascript:;" @click.prevent="$emit('productClicked', product)" class="cl-black card-product-teaser__info__intro__link">
          <p class="card-product-teaser__info__intro__link__name">{{product.name}}</p>
        </a>
        <product-price :product="product" />
      </div>
    </div>
  </div>
</template>

<script>
import ImageGallery from 'theme/components/Product/Image.vue'
import ProductPrice from 'theme/components/Listing/ProductPrice'

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    productImage () {
      if (this.product && this.product.image) {
        return this.product.image.url || ''
      }
      return ''
    }
  },
  components: {
    ImageGallery,
    ProductPrice
  }
}
</script>
